export default {
  supplyInsuranceListByID: {
    method: 'post',
    url: '/supply/insurance/list/ID'
  },
  supplyInsuranceDelete: {
    method: 'delete',
    url: '/supply/insurance'
  },
  supplyInsuranceCreate: {
    method: 'post',
    url: '/supply/insurance'
  },
  supplyInsuranceUpdate: {
    method: 'put',
    url: '/supply/insurance'
  }
}
